import { createContext } from 'react';
import { httpAccountRepository } from './account/httpAccountRepository';
import { httpAudienceRepository } from './audience/httpAudienceRepository';
import { httpCollectionsRepository } from './collections/httpCollectionsRepository';
import { httpCommentsRepository } from './comments/httpCommentsRepository';
import { httpConversationsRepository } from './conversations/httpConversationsRepository';
import { httpDraftSyncTransport } from './drafts/httpDraftSyncTransport';
import { httpInvitationsRepository } from './invitations/httpInvitationsRepository';
import { httpListingsRepository } from './listings/httpListingsRepository';
import { httpPhotoUploadRepository } from './listings/httpPhotoUploadRepository';
import { httpNotificationsRepository } from './notifications/httpNotificationsRepository';
import type { Repositories } from './Repositories';
import { httpSafetyRepository } from './safety/httpSafetyRepository';
import { httpSessionRepository } from './session/httpSessionRepository';

export type { Repositories } from './Repositories';

export const httpRepositories: Repositories = {
  session: httpSessionRepository,
  account: httpAccountRepository,
  invitations: httpInvitationsRepository,
  audience: httpAudienceRepository,
  collections: httpCollectionsRepository,
  listings: httpListingsRepository,
  photoUpload: httpPhotoUploadRepository,
  comments: httpCommentsRepository,
  conversations: httpConversationsRepository,
  safety: httpSafetyRepository,
  notifications: httpNotificationsRepository,
  draftSync: httpDraftSyncTransport,
};

/**
 * Defaults to the real implementations, so the app needs no provider; tests
 * render inside one holding fakes (`renderWithFakes`).
 */
export const RepositoriesContext = createContext<Repositories>(httpRepositories);
